import type { SVGProps } from "react";
export function Check(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m13.0201 4.31307c.1953.19526.1953.51185 0 .70711l-6.66663 6.66662c-.19526.1953-.51185.1953-.70711 0l-2.66666-2.66664c-.19526-.19527-.19526-.5118 0-.70707s.51184-.19527.7071 0l2.31312 2.31311 6.31308-6.31313c.1953-.19526.5119-.19526.7071 0z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
